// src/services/telegramService.js
import axios from 'axios';

const BOT_NAME = process.env.REACT_APP_TELEGRAM_BOT_NAME || 'dng2bot';
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://backend.eldenguee.com';

const getCleanUser = (user) => {
  if (!user) return null;
  const str = String(user).trim();
  if (str === '' || str === 'null' || str === 'undefined') return null;
  return str;
};

/**
 * Persists local cache of verification status
 */
export const setLocalTelegramData = (username, data) => {
  const user = getCleanUser(username);
  if (!user) return;
  const key = `tg_verification_${user}`;
  localStorage.setItem(key, JSON.stringify({
    ...data,
    cachedAt: new Date().toISOString()
  }));
};

/**
 * Gets cached Telegram verification data
 */
export const getLocalTelegramData = (username) => {
  const user = getCleanUser(username);
  if (!user) return null;
  const key = `tg_verification_${user}`;
  const stored = localStorage.getItem(key);
  if (!stored) return null;
  try {
    return JSON.parse(stored);
  } catch {
    return null;
  }
};

/**
 * Generates direct link to Telegram bot with user parameter for verification
 */
export const getBotStartLink = (username) => {
  const user = getCleanUser(username) || 'user';
  // Telegram solo permite caracteres [a-zA-Z0-9_-] en el parámetro start
  const cleanParam = user.replace(/[^a-zA-Z0-9_-]/g, '_');
  return `https://t.me/${BOT_NAME}?start=${cleanParam}`;
};

/**
 * Fetches Telegram verification status from backend API proxy
 */
export const fetchTelegramStatus = async (username, telegramId = null) => {
  const user = getCleanUser(username);
  try {
    const params = {};
    if (user) params.username = user;
    if (telegramId) params.telegramId = telegramId;

    if (!user && !telegramId) {
      return {
        verified: false,
        telegramId: null,
        phoneNumber: null,
        isVerified: false
      };
    }

    const res = await axios.get(`${API_BASE_URL}/telegram/status`, { params }).catch(async () => {
      return await axios.get(`${API_BASE_URL}/telegram/status`, { params });
    });

    if (res.data && (res.data.verified || res.data.isVerified)) {
      setLocalTelegramData(user, res.data);
    }
    return res.data;
  } catch (error) {
    console.error('Error obteniendo estado de Telegram:', error);
    const cached = getLocalTelegramData(user);
    if (cached) return cached;

    return {
      verified: false,
      telegramId: null,
      phoneNumber: null,
      isVerified: false,
      error: true
    };
  }
};

/**
 * Submits Telegram Login Widget payload to backend proxy for verification
 */
export const verifyWidgetPayload = async (telegramData, username) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/telegram/verify`, {
      telegramData,
      appUserId: username
    }).catch(async () => {
      return await axios.post(`${API_BASE_URL}/telegram/verify`, {
        telegramData,
        appUserId: username
      });
    });

    if (res.data && res.data.success) {
      setLocalTelegramData(username, res.data.data);
    }
    return res.data;
  } catch (error) {
    console.error('Error al verificar widget de Telegram:', error);
    throw error;
  }
};
